"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _selectors = require("../../../../store/selectors");
var _Checkbox = _interopRequireDefault(require("../../../../../../../ui/Checkbox"));
var _Textarea = _interopRequireDefault(require("../../../../../../../ui/Textarea"));
var _constants = require("../../../../constants");
var _helpers = require("../../helpers");
var _constants2 = require("../../constants");
var _LabelControl = _interopRequireDefault(require("../LabelControl"));
var _styles = _interopRequireDefault(require("../../styles"));
var _TextField = _interopRequireDefault(require("./components/TextField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var OperatorOptions = function OperatorOptions() {
  var options = (0, _reactRedux.useSelector)(_selectors.getOperatorOptions);
  return R.map(function (_ref) {
    var value = _ref.value,
      content = _ref.content,
      type = _ref.props.type;
    var key = (0, _helpers.getOptionKey)(type, value);
    return /*#__PURE__*/_react.default.createElement(_formik.FastField, {
      key: key,
      name: "options.".concat(key),
      render: function render(_ref2) {
        var field = _ref2.field,
          form = _ref2.form;
        var errorMsg = (0, _formik.getIn)(form, "touched.".concat(field.name)) && (0, _formik.getIn)(form, "errors.".concat(field.name));
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, R.equals(_constants.OPTIONS_CONTROLS_TYPES.CHECKBOX, type) && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          checked: Boolean(field.value),
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          label: content,
          onChange: function onChange(isChecked) {
            return form.setFieldValue(field.name, isChecked);
          }
        }), R.includes(type, [_constants.OPTIONS_CONTROLS_TYPES.PHONE, _constants.OPTIONS_CONTROLS_TYPES.DATE, _constants.OPTIONS_CONTROLS_TYPES.EMAIL, _constants.OPTIONS_CONTROLS_TYPES.TEXT]) && /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
          errorMsg: errorMsg,
          label: content,
          mask: type === _constants.OPTIONS_CONTROLS_TYPES.DATE ? _constants2.PHONE_MASK : undefined,
          name: field.name,
          placeholder: type === _constants.OPTIONS_CONTROLS_TYPES.PHONE ? _constants2.PHONE_PLACEHOLDER : undefined
        }, field, {
          onChange: function onChange(_, event) {
            return field.onChange(event);
          }
        })), R.equals(_constants.OPTIONS_CONTROLS_TYPES.TEXTAREA, type) && /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
          className: (0, _classnames.default)(_styles.default.comment, _styles.default.label),
          id: field.name,
          label: content
        }, /*#__PURE__*/_react.default.createElement(_Textarea.default, _extends({
          className: _styles.default.select,
          errorMsg: errorMsg,
          hasError: Boolean(errorMsg),
          id: field.name
        }, field, {
          onChange: function onChange(_, event) {
            return field.onChange(event);
          }
        }))));
      }
    });
  }, options);
};
var _default = exports.default = (0, _react.memo)(OperatorOptions);